/* eslint-disable */

(function() {
  "use strict";

  var $updateRegion = $(".js-side-menu-update");
  var $mapRegion = $(".map-region");
  var $toolTip = $(".js-map-tooltip");
  var $submitBtn = $(".js-submit-region-btn");

  var $menuCloseBtn = $(".js-close-menu-btn");
  var $regionSideMenu = $(".js-region-side-menu");
  var $dropDown = $(".educational-map__dropdown");

  var active = "is-active";

  $mapRegion.hover(
    function() {
      var $this = $(this);
      var toolTipPosX = [
        60,
        140,
        160,
        160,
        215,
        253,
        285,
        180,
        195,
        170,
        180,
        195
      ];
      var toolTipPosY = [
        245,
        150,
        347,
        410,
        390,
        395,
        350,
        340,
        330,
        275,
        265,
        235
      ];
      var posX = toolTipPosX[$this.index()];
      var posY = toolTipPosY[$this.index()];

      $toolTip.html($this.data("region"));
      $toolTip.css({
        top: posY + "px",
        left: posX + "px"
      });

      $toolTip.addClass(active);
    },
    function() {
      $toolTip.removeClass(active);
    }
  );

  $submitBtn.on("click", function(e) {
    showUpdate();
    if (!$regionSideMenu.hasClass(active)) {
      $regionSideMenu.addClass(active);
    }
  });

  $mapRegion.on("click", function(e) {
    var $this = $(this);
    e.preventDefault();
    $dropDown
      .val($this.data("code"))
      .trigger("chosen:updated")
      .trigger("liszt:updated");
    $submitBtn.trigger("click");
  });

  $menuCloseBtn.on("click", function(e) {
    e.preventDefault();
    $regionSideMenu.removeClass(active);
  });
})();
